import React, { Component } from 'react';
import { Button, Col, Icon, message, Row, Table } from 'antd';
import { Link } from 'react-router';
import moment from 'moment';
import { connect } from 'react-redux';

import {
  queryAllotContract,
  queryContractList,
  queryDeleteContract,
  queryExportContract,
  queryInvalidContract,
  queryLostContract,
  queryRecycleContract,
  queryRestoreContract,
  queryTransferContractConfirm,
  queryTransferContractRefuse,
  queryUseContract,
} from '@api/xxcrm/contract';
import { queryAccountInfo } from '@api/core/user';

import { getContractType } from '@store/modules/contract_type';
import ModalUse from './ModalUse';
import ModalAdd from './ModalAdd';
import ModalAddGroup from './ModalAddGroup';
import ModalAllot from './ModalAllot';
import ModalApply from './ModalApply';
import SearchForm from './FormSearch';
import ModalRecord from './ModalRecord';
import ModalAgree from './ModalAgree';
import ModalTip from './ModalTip';
import ModalInvalid from './ModalInvalid';
import ModalLost from './ModalLost';
import ModalTransfer from './ModalTransfer';
import ModalDealTransfer from './ModalDealTransfer';

// import { getAccountInfo } from "../../../store/modules/account_info";

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pageNo: 1,
      useModalVisible: false,
      addModalVisible: false,
      addGroupVisible: false,
      allotModalVisible: false,
      recordModalVisible: false,
      agreeModalVisible: false,
      tipModalVisible1: false,
      tipModalVisible2: false,
      tipModalVisible3: false,
      tipModalVisible4: false,
      tipModalVisible5: false,
      transferVisible: false,
      total: 0,
      selectedRowKeys: [],
      account_info: this.props.account_info || {},
      permission: {},
    };
  }

  componentWillMount() {
    this.maturity = '';
    this.status = '';
    this.type = '';
    this.no = '';
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getContractType());
    // dispatch(getAccountInfo());
    this.loadDate(1, 15);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.account_info !== nextProps.account_info) {
      this.setState({
        account_info: nextProps.account_info,
      });
      this.judge(nextProps.account_info);
    }
  }

  /**
   * 获取用户信息
   */
  getAccountInfo = () => {
    queryAccountInfo().then(res => {});
  };

  loadDate = (pageNo, pageSize, no, maturity, status, type) => {
    const params = {};
    const context = this;
    const statePageNo = this.state.pageNo;
    const current = pageNo || statePageNo;
    params.limit = 15;
    params.start = current;
    params.no = no || this.no;
    params.maturity = maturity || this.maturity;
    params.type = type || this.type;
    if (!params.maturity) {
      delete params.maturity;
    }
    this.setState({
      pageNo: current,
    });
    params.status = status || this.status;
    if (params.status < 0) {
      params.status = '';
    }
    if (params.type < 0) {
      params.type = '';
    }
    queryContractList(params).then(res => {
      if (res.statusCode === 200) {
        res.data.map((item, index) => {
          item.type = this.findContractType(item.type);
          return item;
        });
        context.setState({
          data: res.data,
          total: res.totalSize,
        });
      }
    });
  };

  loadContractType = () => {
    getContractType().then(res => {
      if (res.statusCode === 200) {
        this.setState({});
      }
    });
  };

  search = condition => {
    const type = parseInt(condition.type, 10) >= 0 ? condition.type : '';
    const status = parseInt(condition.status, 10) >= 0 ? condition.status : '';
    this.no = condition.no ? condition.no : '';
    this.maturity = condition.maturity;
    this.status = status;
    this.type = type;
    this.loadDate(1, 15, condition.no, condition.maturity, condition.status, condition.type);
  };

  /**
   * 作废所选合同
   */
  invalidContract = params => {
    params.uuids = this.state.selectedRowKeys;
    queryInvalidContract(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.cancel();
        this.loadDate();
        this.setState({
          selectedRowKeys: [],
        });
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 删除选中合同
   */
  deleteContract = () => {
    queryDeleteContract(this.state.selectedRowKeys).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.cancel();
        this.loadDate();
        this.setState({
          selectedRowKeys: [],
        });
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 遗失选中合同
   */
  lostContract = params => {
    params.uuids = this.state.selectedRowKeys;
    queryLostContract(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.cancel();
        this.loadDate();
        this.setState({
          selectedRowKeys: [],
        });
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 恢复合同
   */
  restoreContract = () => {
    queryRestoreContract(this.state.selectedRowKeys).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.cancel();
        this.loadDate();
        this.setState({
          selectedRowKeys: [],
        });
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 回收合同
   */
  recycleContract = () => {
    queryRecycleContract(this.state.selectedRowKeys).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.cancel();
        this.loadDate();
        this.setState({
          selectedRowKeys: [],
        });
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 使用合同
   */
  useContract = params => {
    params.uuid = this.record.uuid;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    queryUseContract(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.cancel();
        this.loadDate();
      } else {
        message.error(res.message);
      }
    });
    this.setState({
      selectedRowKeys: [],
    });
  };

  /**
   * 分配合同
   */
  allotContract = params => {
    params.uuids = this.state.selectedRowKeys;
    queryAllotContract(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.cancel();
        this.loadDate();
        this.setState({
          selectedRowKeys: [],
        });
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 转移合同确认
   */
  transferContractConfirm = params => {
    queryTransferContractConfirm(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.cancel();
        this.loadDate();
      } else {
        message.error(res.message);
      }
    });
    this.setState({
      selectedRowKeys: [],
    });
  };

  /**
   * 转移合同拒绝
   */
  transferContractRefuse = params => {
    params.uuids = this.state.selectedRowKeys;
    queryTransferContractRefuse(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.cancel();
        this.loadDate();
      } else {
        message.error(res.message);
      }
    });
    this.setState({
      selectedRowKeys: [],
    });
  };

  /**
   * 显示使用合同弹窗
   */
  showUseModal = record => {
    this.record = record;
    this.setState({
      useModalVisible: true,
    });
  };

  /**
   * 显示转移框
   */
  showTransModal = () => {
    const { selectedRowKeys, data } = this.state;
    const statusArr = [];
    let canTransfer = false;
    selectedRowKeys.map((item, index) => {
      data.map(item2 => {
        if (item2.uuid === item) {
          statusArr.push(item2.status);
        }
        return statusArr;
      });
      return statusArr;
    });
    canTransfer = statusArr.some((item, index) => {
      return item === 4;
    });
    if (this.state.selectedRowKeys.length < 1) {
      message.warn('请先选择待处理的合同！');
    } else if (!canTransfer) {
      message.warn('合同不能转移！');
    } else {
      this.setState({
        transferVisible: true,
      });
    }
  };

  /**
   * 显示删除操作确认框
   */
  showTipModal1 = () => {
    if (this.state.selectedRowKeys.length < 1) {
      message.warn('请先选择待处理的合同！');
    } else {
      this.setState({
        tipModalVisible1: true,
      });
    }
  };

  /**
   * 显示作废操作确认框
   */
  showTipModal2 = () => {
    if (this.state.selectedRowKeys.length < 1) {
      message.warn('请先选择待作废的合同！');
    } else {
      this.setState({
        tipModalVisible2: true,
      });
    }
  };

  /**
   * 显示遗失操作确认框
   */
  showTipModal3 = () => {
    if (this.state.selectedRowKeys.length < 1) {
      message.warn('请先选择遗失的合同！');
    } else {
      this.setState({
        tipModalVisible3: true,
      });
    }
  };

  /**
   * 显示恢复操作确认框
   */
  showTipModal4 = () => {
    if (this.state.selectedRowKeys.length < 1) {
      message.warn('请先选择待处理的合同！');
    } else {
      this.setState({
        tipModalVisible4: true,
      });
    }
  };

  nd;
  /**
   * 显示回收操作确认框
   */

  showTipModal5 = () => {
    if (this.state.selectedRowKeys.length < 1) {
      message.warn('请先选择待处理的合同！');
    } else {
      this.setState({
        tipModalVisible5: true,
      });
    }
  };

  cancel = () => {
    this.setState({
      useModalVisible: false,
      addModalVisible: false,
      addGroupVisible: false,
      allotModalVisible: false,
      applyModalVisible: false,
      recordModalVisible: false,
      agreeModalVisible: false,
      tipModalVisible1: false,
      tipModalVisible2: false,
      tipModalVisible3: false,
      tipModalVisible4: false,
      tipModalVisible5: false,
      transferVisible: false,
      transferConfirmVisible: false,
      transferRefuseVisible: false,
    });
  };

  showAllotModal = () => {
    if (this.state.selectedRowKeys < 1) {
      message.warn('请先选择待分配的合同！');
    } else {
      this.setState({
        allotModalVisible: true,
      });
    }
  };

  showAgreeModal = (record, deal) => {
    this.setState({
      agreeModalVisible: true,
    });
    this.record = record;
    this.deal = deal;
  };

  showConfirmTransferModal = (record, deal) => {
    this.setState({
      transferConfirmVisible: true,
    });
    this.record = record;
  };

  showRefuseTransferModal = (record, deal) => {
    this.setState({
      transferRefuseVisible: true,
    });
    this.record = record;
  };

  showModal = (type, contractUuid) => {
    /* 1使用丨2添加丨3批量添加丨4分配丨5合同申请 丨6操作记录 丨7同意使用 丨8拒绝使用 */
    if (type === 1) {
      this.setState({
        useModalVisible: true,
      });
    } else if (type === 2) {
      this.setState({
        addModalVisible: true,
      });
    } else if (type === 3) {
      this.setState({
        addGroupVisible: true,
      });
    } else if (type === 5) {
      this.setState({
        applyModalVisible: true,
      });
    } else if (type === 6) {
      this.setState({
        recordModalVisible: true,
        contractUuid,
      });
    }
  };

  onSelectChange = selectedRowKeys => {
    this.setState({
      selectedRowKeys,
    });
  };

  findContractType = id => {
    const { list } = this.props;
    const type = list.map((item, index) => {
      if (parseInt(item.value, 10) === parseInt(id, 10)) {
        return item.key;
      }
      return type;
    });
    for (let i = 0; i < list.length; i++) {
      if (parseInt(list[i].value, 10) === parseInt(id, 10)) {
        return list[i].key;
      }
    }
    return type;
  };

  /**
   * 依据角色判断权限
   */
  judge = accountInfo => {
    const role = accountInfo.roles;
    const permission = {};
    role.map((sign, index) => {
      if (sign === '[XxSales]' || sign === '[XxSalesManager]') {
        permission.search = true;
        permission.use = true;
        permission.transfer = true;
        permission.apply = true;
        permission.apply_list = true;
      } else if (sign === '[FinanceMenber]') {
        permission.all = true;
        permission.transfer = false;
      } else if (sign === '[XZManager]') {
        permission.search = true;
        permission.use = true;
        permission.transfer = false;
        permission.apply = true;
        permission.apply_list = true;
        permission.allot = true;
        permission.invalid = true;
        permission.lost = true;
        permission.recover = true;
        permission.recycle = true;
        permission.export = true;
      }
      return permission;
    });
    if (accountInfo.admin) {
      permission.all = true;
      permission.transfer = true;
    }
    this.setState({
      permission,
    });
  };

  /**
   * 导出合同
   */
  exportContract = () => {
    const params = {};
    params.no = this.no;
    if (params.maturity) {
      params.maturity = this.maturity;
    }
    params.status = this.status;
    params.type = this.type;
    queryExportContract(params);
  };

  handSubmit = () => {
    this.loadDate();
    this.cancel();
    this.setState({
      selectedRowKeys: [],
    });
  };

  columns = () => {
    const { permission, account_info: accountInfo } = this.state;
    return [
      {
        title: '合同编号',
        dataIndex: 'no',
        key: 'no',
      },
      {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        render: (text, record) => {
          let status = '';
          if (text === 0) {
            status = '未使用';
          } else if (text === 1) {
            status = '已使用';
          } else if (text === 2) {
            status = '遗失';
          } else if (text === 3) {
            status = '作废';
          } else if (text === 4) {
            status = '已分配';
          } else if (text === 5) {
            status = '待审核';
          } else if (text === 6) {
            status = '转移中';
          }
          return <span>{status}</span>;
        },
      },
      {
        title: '合同类型',
        dataIndex: 'type',
        key: 'type',
        render: (text, record) => {
          // let type = this.find_contract_type(text)
          return <span>{text}</span>;
        },
      },
      {
        title: '创建时间',
        dataIndex: 'cdate',
        key: 'cdate',
        render: (text, record) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '到期时间',
        dataIndex: 'maturityDate',
        key: 'maturityDate',
        render: (text, record) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '分配时间',
        dataIndex: 'allocateDate',
        key: 'allocateDate',
        render: (text, record) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '所属人',
        dataIndex: 'belonging',
        key: 'belonging',
      },
      {
        title: '订单编号',
        dataIndex: 'orderNo',
        key: 'orderNo',
      },
      {
        title: '客户名称',
        dataIndex: 'customName',
        key: 'customName',
      },
      {
        title: '操作',
        key: 'done',
        render: (rext, record) => (
          <span>
            <a onClick={() => this.showModal(6, record.uuid)}>查看</a>
            {record.status === 4 && record.belongUser === accountInfo.userUuid ? (
              <span>
                丨<a onClick={() => this.showUseModal(record)}>使用</a>
              </span>
            ) : (
              ''
            )}
            {
              // 是否同意使用合同的申请
              record.status === 5 && permission.all ? (
                <span>
                  丨<a onClick={() => this.showAgreeModal(record, 'agree')}>同意</a>丨
                  <a onClick={() => this.showAgreeModal(record, 'refuse')}>拒绝</a>
                </span>
              ) : (
                ''
              )
            }
            {
              // 是否同意转移合同的申请
              record.status === 6 && record.transferUser === accountInfo.userUuid ? (
                <span>
                  丨<a onClick={() => this.showConfirmTransferModal(record)}>接收</a>丨
                  <a onClick={() => this.showRefuseTransferModal(record)}>拒绝</a>
                </span>
              ) : (
                ''
              )
            }
          </span>
        ),
      },
    ];
  };

  render() {
    const { data, total, selectedRowKeys, permission } = this.state;
    const pagination = {
      total,
      showSizeChanger: false,
      pageSize: 15,
      current: this.state.pageNo,
      onChange: current => {
        this.loadDate(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const {
      useModalVisible,
      agreeModalVisible,
      addModalVisible,
      allotModalVisible,
      addGroupVisible,
      applyModalVisible,
      tipModalVisible1,
      transferVisible,
      recordModalVisible,
      tipModalVisible2,
      tipModalVisible3,
      tipModalVisible4,
      tipModalVisible5,
      transferConfirmVisible,
      transferRefuseVisible,
    } = this.state;
    return (
      <div className="fixed-box">
        <div className="fixed-header">
          <Row type="flex" className="btn-group">
            <Col span={16}>
              <ul className="table-menu">
                {permission.add || permission.all ? (
                  <li onClick={() => this.showModal(2)}>
                    <Icon type="addc" />
                    <span>添加</span>
                  </li>
                ) : (
                  ''
                )}
                {permission.adds || permission.all ? (
                  <li onClick={() => this.showModal(3)}>
                    <Icon type="addcs" />
                    <span>批量添加</span>
                  </li>
                ) : (
                  ''
                )}
                {permission.delete || permission.all ? (
                  <li onClick={this.showTipModal1}>
                    <Icon type="deletec" />
                    <span>删除</span>
                  </li>
                ) : (
                  ''
                )}
                {permission.allot || permission.all ? (
                  <li onClick={this.showAllotModal}>
                    <Icon type="allot" />
                    <span>分配</span>
                  </li>
                ) : (
                  ''
                )}
                {permission.invalid || permission.all ? (
                  <li onClick={this.showTipModal2}>
                    <Icon type="cancel" />
                    <span>作废</span>
                  </li>
                ) : (
                  ''
                )}
                {permission.lost || permission.all ? (
                  <li onClick={this.showTipModal3}>
                    <Icon type="lose" />
                    <span>遗失</span>
                  </li>
                ) : (
                  ''
                )}
                {permission.recover || permission.all ? (
                  <li onClick={this.showTipModal4}>
                    <Icon type="recover" />
                    <span>恢复</span>
                  </li>
                ) : (
                  ''
                )}
                {permission.recycle || permission.all ? (
                  <li onClick={this.showTipModal5}>
                    <Icon type="recycle" />
                    <span>回收</span>
                  </li>
                ) : (
                  ''
                )}
                <li onClick={this.showTransModal}>
                  <Icon type="transfer" />
                  <span>转移</span>
                </li>
              </ul>
            </Col>
            <Col span={8}>
              <Row type="flex" justify="end" className="btn-group">
                {permission.apply || permission.all ? (
                  <Col>
                    <Button onClick={() => this.showModal(5)}>合同申请</Button>
                  </Col>
                ) : (
                  ''
                )}
                <Col>
                  <Link to="/xianxing/contract/apply">
                    <Button>申请列表</Button>
                  </Link>
                </Col>
                {permission.export || permission.all ? (
                  <Col>
                    <Button onClick={this.exportContract}>导出</Button>
                  </Col>
                ) : (
                  ''
                )}
              </Row>
            </Col>
          </Row>
          <Row justify="space-between" type="flex" style={{ marginBottom: '16px' }}>
            <Col span={24}>
              <SearchForm search={this.search} />
            </Col>
          </Row>
        </div>
        <Table
          rowKey="uuid"
          rowSelection={rowSelection}
          columns={this.columns()}
          dataSource={data}
          pagination={pagination}
          style={{ paddingTop: '120px' }}
        />
        {/* 弹窗 */}
        {
          // 合同使用弹窗
          useModalVisible ? (
            <ModalUse cancel={this.cancel} handSubmit={this.useContract} record={this.record} />
          ) : (
            ''
          )
        }
        {
          // 添加单个合同
          addModalVisible ? <ModalAdd cancel={this.cancel} loadDate={this.loadDate} /> : ''
        }
        {
          /* 合同批量添加 */
          addGroupVisible ? <ModalAddGroup cancel={this.cancel} loadDate={this.loadDate} /> : ''
        }
        {
          // 合同分配
          allotModalVisible ? (
            <ModalAllot cancel={this.cancel} handSubmit={this.allotContract} />
          ) : (
            ''
          )
        }
        {
          // 合同转移
          transferVisible ? (
            <ModalTransfer
              cancel={this.cancel}
              handSubmit={this.handSubmit}
              uuids={selectedRowKeys}
            />
          ) : (
            ''
          )
        }
        {
          // 接收转移的合同
          transferConfirmVisible ? (
            <ModalDealTransfer
              cancel={this.cancel}
              handSubmit={this.handSubmit}
              deal="confirm"
              record={this.record}
            />
          ) : (
            ''
          )
        }
        {
          // 拒绝转移的合同
          transferRefuseVisible ? (
            <ModalDealTransfer
              cancel={this.cancel}
              handSubmit={this.handSubmit}
              deal="refuse"
              record={this.record}
            />
          ) : (
            ''
          )
        }
        {
          // 申请合同
          applyModalVisible ? <ModalApply cancel={this.cancel} loadDate={this.loadDate} /> : ''
        }
        {
          // 同意合同使用申请
          agreeModalVisible ? (
            <ModalAgree
              cancel={this.cancel}
              loadDate={this.loadDate}
              deal={this.deal}
              record={this.record}
            />
          ) : (
            ''
          )
        }
        {
          // 删除合同确认
          tipModalVisible1 ? <ModalTip cancel={this.cancel} handSubmit={this.deleteContract} /> : ''
        }
        {
          // 作废合同确认
          tipModalVisible2 ? (
            <ModalInvalid cancel={this.cancel} handSubmit={this.invalidContract} />
          ) : (
            ''
          )
        }
        {
          // 遗失合同
          tipModalVisible3 ? <ModalLost cancel={this.cancel} handSubmit={this.lostContract} /> : ''
        }
        {
          // 恢复合同
          tipModalVisible4 ? (
            <ModalTip cancel={this.cancel} handSubmit={this.restoreContract} />
          ) : (
            ''
          )
        }
        {
          // 回收合同
          tipModalVisible5 ? (
            <ModalTip cancel={this.cancel} handSubmit={this.recycleContract} />
          ) : (
            ''
          )
        }
        {
          // 合同操作日志
          recordModalVisible ? (
            <ModalRecord cancel={this.cancel} contractUuid={this.state.contractUuid} />
          ) : (
            ''
          )
        }
      </div>
    );
  }
}

export default connect(state => ({
  list: state.contract_type,
  account_info: state.account_info,
}))(Index);



// WEBPACK FOOTER //
// ./src/components/xianxing/contract/Index.js